module.exports = __webpack_public_path__ + "static/img/P3.a647fe82.jpg";